'use strict';

const invalidFeedback = require('capency/capency/utils/invalidFeedback');
var capPEmailConfiguration = require('./function');
var keyTimer;
var keyTimer2;
let capencyFields = [];

/**
* Configures email validation and event handling for a specified form.
*
* This function retrieves the configuration for the specified form ID, determines if the form is editable,
* and sets up event listeners for email fields to handle keydown and input events. It also manages the
* validation state of the email fields and handles the behavior of update and save address buttons.
*
* @param {string} formID - The ID of the form to configure.
* @returns {boolean} Always returns false.
*/
function setConfigToCapEmail(formID) {
    // get config from de request Ajav for the currentForm
    var isEditableForm = false;

    var $formSelector = $("form[id='" + formID + "']");

    if ($formSelector.length === 0) {
        $formSelector = $("form[name='" + formID + "']");
    }

    if ($formSelector.is('[class*="edit"]')) {
        isEditableForm = true;
    }

    var config = capPEmailConfiguration.getConfig(formID, isEditableForm);
    var listItem = [];

    if (config) {
        // events keyup keypress keydown for multiple NumberPhone for the form
        if (config.hasOwnProperty('emailFieldsIDs')) {
            listItem = config.emailFieldsIDs;

            $.each(listItem, function (key, selectorEmail) {
                let $field = config.formChild ? $formSelector.find('#' + selectorEmail) : $('#' + selectorEmail);
                capencyFields.push($field);
                $field.on('input', function (evt) {
                    var value = evt.target.id;
                    let $this = $(this);
                    let $invalidFeedback = invalidFeedback.getInvalidFeedbackElement($this);
                    $invalidFeedback.empty();
                    if (value === selectorEmail) {
                        clearTimeout(keyTimer);
                        keyTimer = setTimeout(function () {
                            // call ajax for get suggestions
                            config.EmailID = selectorEmail;
                            capPEmailConfiguration.callProcessEmailFlow(config);
                        }, 300);
                    }
                }).on('input', function () {
                    $(this).removeClass('autocomplete-field-selected');
                });
            });

            $('#' + listItem[0]).attr('data-validate-email', false);

            $('.btn-update-address').on('click', function (e) {
                e.preventDefault();
                $('#' + listItem[0]).attr('data-validate-email', false);
                $('#verifyEmail').modal('hide');
                $('#' + listItem[0]).focus();
                $.spinner().stop();
            });

            $('.btn-save-address').on('click', function (e) {
                e.preventDefault();
                $('#' + listItem[0]).attr('data-validate-email', true);
                $('#verifyEmail').modal('hide');
                $.spinner().stop();
            });
        } else {
            capencyFields.push($('#' + config.EmailID));
            $('#' + config.EmailID).attr('data-validate-email', false);
            // events keyup keypress keydown for EmailID
            $('#' + config.EmailID).on('keydown', function () {
                clearTimeout(keyTimer2);
                let $this = $(this);
                let $invalidFeedback = invalidFeedback.getInvalidFeedbackElement($this);
                $invalidFeedback.empty();
                keyTimer = setTimeout(function () {
                    // call ajax for get suggestions
                    capPEmailConfiguration.callProcessEmailFlow(config);
                }, 0);
            }).on('input', function () {
                $(this).removeClass('autocomplete-field-selected');
            });

            $('.btn-update-address').on('click', function (e) {
                e.preventDefault();
                $('#' + config.EmailID).attr('data-validate-email', false);
                $('#' + config.EmailID).focus();
                $('#verifyEmail').modal('hide');
                $.spinner().stop();
            });

            $('.btn-save-address').on('click', function (e) {
                e.preventDefault();
                $('#' + config.EmailID).attr('data-validate-email', true);
                $('input[name$="contactInfoFields_email"]').attr('data-validate-email', true);
                $('input[name$="coCustomer_email"]').attr('data-validate-email', true);
                $('#verifyEmail').modal('hide');
                $.spinner().stop();
            });
        }
        initChangeHandlerOnEmailFields();

        return false;
    }
}

/**
* Disables browser autocomplete for all text input fields within a specified form.
*
* This function searches for a form by its ID or name and sets the `autocomplete` attribute
* of all text input fields within the form to "off", effectively disabling the browser's
* autocomplete feature for those fields.
*
* @param {string} formID - The ID or name of the form for which to disable autocomplete.
*/
function deleteAutoCompleteBrowser(formID) {
    var $formSelector = $("form[id='" + formID + "']");

    if ($formSelector.length === 0) {
        $formSelector = $("form[name='" + formID + "']");
    }

    $formSelector.find('input[type=text]').each(function () {
        $(this).attr('autocomplete', 'off');
    });
}

function initChangeHandlerOnEmailFields() {
    capencyFields.forEach(function (field) {
        field.on('focus', function () {
            $(this).data('oldValue', $(this).val());
        });
        field.on('change', function () {
            if ($(this).val() !== $(this).data('oldValue')) {
                $(this).data('isModified', true);
            }
        });
    });
}

module.exports = {
    initCapEmailByForms: (formIdListToInit = []) => {
        var listFormWithCapAddress = capPEmailConfiguration.getIdForms();
        $('form').each(function () {
            var formID = (String($(this).attr('id')) === 'undefined' || typeof String($(this).attr('id')) === 'undefined') ? $(this).attr('name') : String($(this).attr('id'));
            if (formID && listFormWithCapAddress.includes(formID) && (formIdListToInit.length === 0 || formIdListToInit.includes(formID))) {
                setConfigToCapEmail(formID);
                deleteAutoCompleteBrowser(formID);
            }
        });
    }
};
